<div>
  @if (errorMessage()) {
    <div class="errorMessage">
      {{ errorMessage() }}
    </div>
  }
  @if (isBusy()) {
    <div class="busyIndicator">
      <mat-progress-spinner diameter="24" mode="indeterminate" strokeWidth="1"></mat-progress-spinner>
      <label class="busyLabel">Please Wait...</label>
    </div>
  }
  @if (documents()) {
    <div class="results">
      <table class="resultsTable">
        <thead>
          <tr>
            <td class="tableCell centeredCell headerCell">Name</td>
          </tr>
        </thead>
        @for (document of documents(); track document) {
          <tr>
            <td class="tableCell downloadDocumentCell" (click)="download(document)">{{ document.documentName }}</td>
          </tr>
        }
      </table>
    </div>
  }
</div>
